import { render, staticRenderFns } from "./RenewalReview.vue?vue&type=template&id=6b2b697e&"
import script from "./RenewalReview.vue?vue&type=script&lang=ts&"
export * from "./RenewalReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports